import * as React from 'react';
import { useEffect,useState } from 'react';
import { ScrollView } from "@progress/kendo-react-scrollview";
import { useSearchParams } from 'react-router-dom';

const items = [
    {
        title: "Queues",
        position: 1,
        url: "https://eyedogzsloan.covington.io/#/fmdashboardqueues",
    },
    {
        title: "Agents",
        position: 2,
        url: "https://eyedogzsloan.covington.io/#/fmdashboardagents",
    }
];

const DEFAULT_CHANGE_INTERVAL = 30000;

export const FMDashboard = () => { 
    const [searchParams] = useSearchParams();
    const [changeInterval, setChangeInterval] = useState(DEFAULT_CHANGE_INTERVAL);

    useEffect(() => {

        document.body.style.overflow = 'hidden';
        var changeI = DEFAULT_CHANGE_INTERVAL;
        try {
            changeI = parseInt(searchParams.get('changeInterval'));
            if (isNaN(changeI)) {
                changeI = DEFAULT_CHANGE_INTERVAL;
            }
            changeI = changeI * 1000;
        }
        catch (e) {
            console.log('useEffect: query param changeInterval not provided or invalid format')
            changeI = DEFAULT_CHANGE_INTERVAL;
        }
        setChangeInterval(changeI);
    }, [searchParams, setChangeInterval]);

  return (  
          <ScrollView
          style={{
              width: '100vw',
              height: '100vh',
              border: 'none',
              padding: '0',
              margin: '0',
              overflow: 'hidden',
          }}
          endless={true}
          automaticViewChange={true}
          automaticViewChangeInterval={changeInterval}

          >
              {items.map((item, index) => {
                  return (
                      <div key={index} style={{
                          width: '100%',
                          height: '100%',
                          border: 'none', 
                          padding: '0',
                          margin: '0',
                          overflow: 'hidden',
                      }}> 
                          <iframe title={item.title }
                              src={item.url} 
                              style={{
                                  width: '100%',
                                  height: '100%',
                                  border: 'none', 
                                  padding: '0',
                                  margin: '0',
                                  overflow: 'hidden',
                              }}
                              draggable={false}
                          />
                      </div>
                  );
              })}
          </ScrollView>
  
 
  );

  
  
};


